import React from 'react';
import { StyledCard, CardTitle, StyledFormGroup, TooltipWrapper, InfoIcon } from '../cardStyles';
import { Textarea } from '../../../../../components/styles/modal-style';

interface Props {
  invoice: any;
  readOnly?: boolean;
}

const LabelWithInfo = ({ label, tooltip }: { label: string; tooltip: string }) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <label style={{ marginBottom: 0 }}>{label}</label>
    <TooltipWrapper data-tooltip={tooltip}>
      <InfoIcon>i</InfoIcon>
    </TooltipWrapper>
  </div>
);

const InfoAdicionaisSection: React.FC<Props> = ({ invoice }) => (
  <StyledCard>
    <CardTitle>Inf. Adicionais</CardTitle>
    <StyledFormGroup>
      <LabelWithInfo label="Dados adicionais" tooltip="Observações do Fisco ou do cliente" />
      <Textarea
        style={{ height: '80px' }}
        readOnly
        value={invoice?.dadosAdicionais || ''}
        placeholder="Sem informações adicionais"
      />
    </StyledFormGroup>
  </StyledCard>
);

export default InfoAdicionaisSection;
